import axios from 'axios'
import appConfig from '@/appconfig'
import endpoint from '@constants/apipath'
import store from '../store'

export const actions = {
  getcustomeralerts(
    { commit, dispatch, getters },
    { pageSize, pageNumber, customerId, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${endpoint.reportApiPath.getcustomeralerts}?PageSize=${pageSize}&PageNumber=${pageNumber}&SelectedCustomer=${customerId}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
  },

  getalertslist(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
      customerId,
    } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.getAlertList}` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    if (customerId != null) {
      url = url + '&SelectedCustomer=' + customerId
    }
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  downloadalerts(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      key,
      value,
      sortBy,
      sortDirection,
      customerId,
    } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.reportApiPath.downloadList}` +
      '?Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone
    if (customerId != null) {
      url = url + '&SelectedCustomer=' + customerId
    }
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'Alerts.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Alerts.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  getalertdetails({ commit }, { alertId } = {}) {
    var url = `${appConfig.apiEndPoint}${endpoint.reportApiPath.getAlertDetails}/${alertId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchPortfolios() {
    var url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.getPortfolios}`

    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  getCompanyDetail({ commit }, { companyId } = {}) {
    var url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.getCompanyDetail}/${companyId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
  getCompanies(
    { commit, dispatch, getters },
    {
      startTime,
      endTime,
      timeZone,
      pageSize,
      pageNumber,
      key,
      value,
      sortBy,
      sortDirection,
    } = {}
  ) {
    let url =
      `${appConfig.apiEndPoint}${endpoint.adminApiPath.getCompanies}` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection

    if (startTime !== '' && endTime !== '')
      url +=
        '&FromDate=' +
        startTime +
        '&ToDate=' +
        endTime +
        '&TimeZone=' +
        timeZone
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  downloadCompanies(
    { commit, dispatch, getters },
    { startTime, endTime, timeZone, key, value, sortBy, sortDirection } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${endpoint.adminApiPath.downloadCompanies}` +
      '?Key=' +
      key +
      '&Value=' +
      value +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection +
      '&FromDate=' +
      startTime +
      '&ToDate=' +
      endTime +
      '&TimeZone=' +
      timeZone

    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'Companies.txt')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Companies.txt') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  addCompanies(
    { commit, dispatch, getters },
    {
      companyName,
      addressline1,
      addressline2,
      city,
      stateId,
      zip,
      amsactive,
      bamactive,
      efnumber,
      bin,
      userTrackingId,
      taxId,
      taxIdType,
      phoneNumber,
      portfolioId,
    } = {}
  ) {
    var companyData = {}
    companyData.CompanyName = companyName
    companyData.AddressLine1 = addressline1
    companyData.AddressLine2 = addressline2
    companyData.City = city
    companyData.StateId = stateId
    companyData.Zip = zip
    companyData.AMSActive = amsactive
    companyData.BAMActive = bamactive
    companyData.EquifaxMemberNumber = efnumber
    companyData.BIN = Number(bin)
    companyData.PortfolioId = portfolioId
    companyData.UserTrackingId = userTrackingId
    companyData.BusinessTaxId = taxId
    companyData.BusinessTaxIdType = taxIdType
    companyData.PhoneNo = phoneNumber
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.addCompanies}`,
        companyData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error.response
      })
  },
  removeCompanies({ commit }, { companyId } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.removeCompanies}/${companyId}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  updateCompanies(
    { commit, dispatch, getters },
    {
      companyName,
      addressline1,
      addressline2,
      city,
      stateId,
      zip,
      amsactive,
      bamactive,
      efnumber,
      bin,
      companyId,
      userTrackingId,
      taxId,
      taxIdType,
      phoneNumber,
      portfolioId,
    } = {}
  ) {
    var companyData = {}
    companyData.CompanyName = companyName
    companyData.AddressLine1 = addressline1
    companyData.AddressLine2 = addressline2
    companyData.City = city
    companyData.StateId = stateId
    companyData.Zip = zip
    companyData.AMSActive = amsactive
    companyData.BAMActive = bamactive
    companyData.EquifaxMemberNumber = efnumber
    companyData.BIN = Number(bin)
    companyData.PortfolioId = portfolioId
    companyData.CompanyId = companyId
    companyData.UserTrackingId = userTrackingId
    companyData.BusinessTaxId = taxId
    companyData.BusinessTaxIdType = taxIdType
    companyData.PhoneNo = phoneNumber
    return axios
      .post(
        `${appConfig.apiEndPoint}${endpoint.adminApiPath.updateCompanies}`,
        companyData,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
}
function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}
